import confirmDialog from './confirmDialog';
import openAnnotatedImage from './openAnnotatedImage';
import openImage from './openImage';
import editElement from './editElement';
import saveAnnotation from './saveAnnotation';
import editRegionOfInterest from './editRegionOfInterest';
import summaryImage from './summaryImage';

export {
    confirmDialog,
    openAnnotatedImage,
    openImage,
    editElement,
    saveAnnotation,
    editRegionOfInterest,
    summaryImage
};


// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/dialogs/index.js